/* src/app/modules/accounting/export/accounting-export.component.css */
.ae-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 100%;
  box-sizing: border-box;
}
.ae-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ae-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ae-header__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ae-header__icon mat-icon {
  color: var(--cf-brand-dark);
  font-size: 26px;
  width: 26px;
  height: 26px;
  line-height: 1;
}
.ae-header__title {
  margin: 0 0 2px;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
}
.ae-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.ae-card {
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.ae-card__head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.ae-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ae-card__icon mat-icon {
  color: #e3fd64;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 1;
}
.ae-card__title {
  margin: 0 0 3px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}
.ae-card__sub {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
.ae-card__body {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.ae-field {
  min-width: 140px;
  max-width: 180px;
  flex: 1;
}
:host ::ng-deep .ae-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.ae-toggle {
  align-self: center;
}
.ae-card__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ae-btn-primary {
  background: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ae-btn-primary mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
}
.ae-btn-primary:disabled {
  opacity: 0.6;
}
.ae-loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.ae-loading-dots span {
  display: block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.4;
  animation: ae-pulse 1.1s ease-in-out infinite;
}
.ae-loading-dots span:nth-child(2) {
  animation-delay: .18s;
}
.ae-loading-dots span:nth-child(3) {
  animation-delay: .36s;
}
@keyframes ae-pulse {
  0%, 80%, 100% {
    opacity: .3;
    transform: scale(.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
@media (max-width: 767px) {
  .ae-page {
    padding: 12px;
    gap: 14px;
  }
  .ae-card__body {
    flex-direction: column;
    align-items: stretch;
  }
  .ae-field {
    max-width: none;
  }
}
/*# sourceMappingURL=accounting-export.component.css.map */
